import { UserRolesEnum } from '~/utils/enums/userRoles'

export default defineNuxtRouteMiddleware(async (to) => {
  // Skip authentication check for the login page and report pages
  const reportAccessToken = to.query.reportAccessToken
  const shouldBypassLogin = Boolean(
    (to.path.includes('report') && reportAccessToken)
    || to.path === '/'
    || to.path.startsWith('/web-report/'),
  )
  // validate the report access token
  if (shouldBypassLogin) {
    return
  }

  const { $acquireTokenSilent } = useNuxtApp()
  const accessToken = (await $acquireTokenSilent())?.accessToken
  const { attemptedPath, userRoles } = storeToRefs(useAuthStore())

  if (!accessToken) {
    attemptedPath.value = to.fullPath
    return navigateTo('/')
  }
  else if (
    accessToken
    && !userRoles.value.includes(UserRolesEnum.GLOBAL_ADMIN)
    && !userRoles.value.includes(UserRolesEnum.WORKSPACE_ADMIN)
    && to.path.includes('/admin')
  ) {
    return navigateTo('/projects')
  }
})
